export const getAlignedAnswerValues = (
  answerValues: string[],
  optionsLength: number
): string[] =>
  Array.from(
    { length: optionsLength },
    (_, index) => answerValues[index] ?? ''
  );
